<template>
  <v-flex class="px-3">
    <div class="data-table-header">
      <span class="text-h6 font-weight-bold">목록 (총 {{ data.length }}개)</span>
      <div class="buttons-layout">
        <v-flex xs4>
          <v-select
            v-model="useYn"
            :items="useYnList"
            item-text="text"
            item-value="value"
            outlined hide-details dense
            background-color="white"
            @change="changeUseYn"
          />
        </v-flex>
        <v-btn class="button save" outlined @click="categoryPopupOpen(null)">카테고리 추가</v-btn>
      </div>
    </div>
    <v-data-table
        height="65vh"
        fixed-header
        :headers="getHeader(headers)"
        :items="data"
        :loading="loading"
        :items-per-page="-1"
        no-data-text="조회된 데이터가 없습니다"
        mobile-breakpoint="md"
    >
      <template v-slot:item.useRole="{ value }">
        <div>{{ dataConversion(useRoleList, value) }}</div>
      </template>
      <template v-slot:item.useYn="{ value }">
        <div>{{ dataConversion(useYnList, value) }}</div>
      </template>
      <template v-slot:item.modify="{ item }">
        <v-btn class="button" outlined @click="categoryPopupOpen(item)">수정</v-btn>
      </template>
    </v-data-table>
    <CategoryPopup
        :is-show="isShowAdd"
        :editItemProps="editItem"
        :type="popupType"
        @refresh="$emit('refresh')"
        @close="isShowAdd = false"
    />
  </v-flex>
</template>

<script>
import _ from "lodash";
import TableMixin from "@/mixin/TableMixin";
import DateMixin from "@/mixin/DateMixin";
import CategoryPopup from "@/pages/Lecture/popup/CategoryPopup.vue";
import {LECTURE_CATEGORY_TABLE} from "@/util/TableHeaders";
import constant from "@/util/constant";

export default {
  name: "LectureCategoryTable",

  components: {CategoryPopup},
  props: ["data", "loading"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      headers: LECTURE_CATEGORY_TABLE,
      useRoleList: constant.MEMBER_ROLE_LIST,
      useYn: "",
      useYnList: [
        { text: "전체", value: "" },
        { text: "노출", value: "Y" },
        { text: "미노출", value: "N" }
      ],
      isShowAdd: false,
      editItem: [],
      popupType: '',

    }
  },

  created() {
    // (임시처리) 실제 api 로 받을때 카테고리 목록에 no 값이 있을지 모름
    // this.data = this.data.map((item, i) => ({no: i + 1, ...item}));
  },


  methods: {
    changeUseYn(useYn) {
      this.$emit('change', useYn);
    },
    categoryPopupOpen(item){
      const type = _.isEmpty(item) ? 'new' : 'edit';

      this.editItem = item;
      this.popupType = type;
      this.isShowAdd = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>